import { render, staticRenderFns } from "./StoreManager.vue?vue&type=template&id=1ff42a16&scoped=true&"
import script from "./StoreManager.vue?vue&type=script&lang=js&"
export * from "./StoreManager.vue?vue&type=script&lang=js&"
import style0 from "./StoreManager.vue?vue&type=style&index=0&id=1ff42a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff42a16",
  null
  
)

export default component.exports